<template>
    <div :ref="swiperRef" class="swiper-container">
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
        <template v-if="showNavigation">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </template>

        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
import { Swiper, Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
    props: {
        name: { type: String, required: true },
        slidesPerViewMobile: { type: Number, default: 2 },
        slidesPerViewTablet: { type: Number, default: 3 },
        slidesPerViewDesktop: { type: Number, default: 4 },
        slidesPerViewLargeDesktop: { type: Number, default: 5 },
        spaceBetween: { type: Number, default: 0 },
        speed: { type: Number, default: 5000 },
        autoplayDelay: { type: Number, default: 0 },
        autoplayDisableOnInteraction: { type: Boolean, default: false },
        loop: { type: Boolean, default: true },
        freeMode: { type: Boolean, default: true },
        showNavigation: { type: Boolean, default: false },
        showPagination: { type: Boolean, default: false },
    },
    data() {
        return {
            swiperInstance: null,
        }
    },
    computed: {
        swiperRef() {
            return `swiper-${this.name}`
        },
    },
    mounted() {
        this.checkSwiperInitialization()
        window.addEventListener('resize', this.checkSwiperInitialization)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkSwiperInitialization)
        if (this.swiperInstance) {
            this.swiperInstance.destroy()
        }
    },
    methods: {
        checkSwiperInitialization() {
            const shouldInitialize = this.shouldInitializeSwiper()
            if (shouldInitialize && !this.swiperInstance) {
                this.swiperInstance = new Swiper(this.$refs[this.swiperRef], {
                    modules: [Autoplay, Navigation, Pagination],
                    spaceBetween: this.spaceBetween,
                    speed: this.speed,
                    autoplay: {
                        delay: this.autoplayDelay,
                        disableOnInteraction: this.autoplayDisableOnInteraction,
                    },
                    loop: this.loop,
                    freeMode: this.freeMode,
                    slidesPerView: this.slidesPerViewMobile,
                    breakpoints: {
                        768: {
                            slidesPerView: this.slidesPerViewTablet,
                        },
                        1024: {
                            slidesPerView: this.slidesPerViewDesktop,
                        },
                        1440: {
                            slidesPerView: this.slidesPerViewLargeDesktop,
                        },
                    },
                    navigation: this.showNavigation ? {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    } : false,
                    pagination: this.showPagination ? {
                        el: '.swiper-pagination',
                        clickable: true,
                    } : false,
                })
            } else if (!shouldInitialize && this.swiperInstance) {
                this.swiperInstance.destroy()
                this.swiperInstance = null
            }
        },

        shouldInitializeSwiper() {
            const slotContentLength = this.$slots.default ? this.$slots.default.length : 0;
            const isMobile = window.innerWidth < 768
            const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024
            const isDesktop = window.innerWidth >= 1024
            const isLargeDesktop = window.innerWidth >= 1440

            return (
                (isMobile && slotContentLength >= this.slidesPerViewMobile) ||
                (isTablet && slotContentLength >= this.slidesPerViewTablet) ||
                (isDesktop && slotContentLength >= this.slidesPerViewDesktop) ||
                (isLargeDesktop && slotContentLength >= this.slidesPerViewLargeDesktop)
            )
        },
    },
}
</script>